import { useUIMode } from '../../context/UIModeContext';

/**
 * ModeToggle - Pill-style segmented toggle for Simple/Advanced mode
 *
 * Features:
 * - Full-width pill-style design optimized for header
 * - Shows both Simple and Advanced options side by side
 * - Active mode is highlighted with white background and shadow
 * - Inactive mode is gray text, clickable to switch
 * - Uses header-layout.css styles
 */

export function ModeToggle(): JSX.Element {
  const { setMode, isSimple } = useUIMode();

  return (
    <div className="ui-mode-toggle">
      {/* Simple Mode Button */}
      <button
        onClick={() => setMode('simple')}
        className={`simple-mode ${isSimple ? 'active' : ''}`}
        aria-pressed={isSimple}
      >
        Simple
      </button>

      {/* Advanced Mode Button */}
      <button
        onClick={() => setMode('advanced')}
        className={`advanced-mode ${!isSimple ? 'active' : ''}`}
        aria-pressed={!isSimple}
      >
        Advanced
      </button>
    </div>
  );
}
